import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@material-ui/core/Box';
import { money } from 'utils';
import { updateGlobalOption } from 'store/actions/cart';
import OptionsSection from 'components/OptionsSection';

const GlobalOptions = () => {
  const dispatch = useDispatch();
  const { globalOptions } = useSelector((s) => s.lab);
  const { orderOptions = {} } = useSelector((s) => s.cart);

  // Load user preferences and apply them only once when component mounts
  useEffect(() => {
    const savedPreferences = localStorage.getItem('userPreferences');
    if (savedPreferences) {
      try {
        const preferences = JSON.parse(savedPreferences);

        // Only apply preferences for options that haven't been selected yet
        const preferencesToApply = {};
        Object.keys(preferences).forEach((optionId) => {
          if (!orderOptions[optionId]) {
            preferencesToApply[optionId] = preferences[optionId];
          }
        });

        // Apply preferences if there are any to apply
        if (Object.keys(preferencesToApply).length > 0) {
          dispatch(updateGlobalOption(preferencesToApply));
        }
      } catch (error) {
        console.error('Error loading user preferences:', error);
      }
    }
  }, []); // Empty dependency array - run only once on mount

  const handleOptionChange = (optionId, value) => {
    dispatch(
      updateGlobalOption({
        [optionId]: value,
      })
    );
  };

  return (
    <Box>
      {globalOptions.global_checkout_options.map((option) => {
        const isOptionSelected = orderOptions[option.id];
        
        const getOptionLabel = (choice) => {
          const pcontotal = choice.pcontotal
            ? ` + ${choice.pcontotal}% of cart total`
            : '';
          return choice.label +
            ' - ' +
            money(choice.price, globalOptions.currency) +
            (choice.priceperfile ? ' per file' : '') +
            pcontotal;
        };

        return (
          <OptionsSection
            key={option.id}
            title={option.description}
            subtitle={option.subtitle}
            options={option.choices}
            selectedValue={orderOptions[option.id]}
            onOptionChange={(choiceId) => handleOptionChange(option.id, choiceId)}
            isRequired={option.required}
            getOptionLabel={getOptionLabel}
            currency={globalOptions.currency}
          />
        );
      })}
    </Box>
  );
};

export default GlobalOptions;
